import { createContext } from "react";

type WidgetFrameTitleContextProps = {
    title: string | null;
};

export const WidgetFrameTitleContext = createContext<WidgetFrameTitleContextProps>({
    title: null,
});
